module.exports = __webpack_public_path__ + "img/mode-3.e1676403.png";